import MenuAddModal from './MenuAddModal';

export default MenuAddModal;
